import { DEFAULT_NEW_BANNER } from "@constants/global";

export const PublicProfileTab = {
  Endorsement: "endorsement",
  Appreciation: "appreciation",
  Certifications: "certifications",
  Projects: "projects",
  Recognitions: "recognitions",
} as const;

export type PublicProfileTabValue =
  (typeof PublicProfileTab)[keyof typeof PublicProfileTab];

export const DEFAULT_COVER_IMAGE = DEFAULT_NEW_BANNER;
